<template>
    <Card class="card" @submitted="saveModel">
        <template #title>
            Експорт користувачів
        </template>

        <template #content>

            <!-- Name -->
            <div class="field">
                <label for="name"><b>Дозволені IP (через ; без відступів)</b></label>
                <InputText
                    class="w-full"
                    type="text"
                    v-model="model.ips"
                />
            </div>
        </template>

        <template #footer>
            <Button
                label="Зберегти"
                @click="saveModel"
            />
        </template>
    </Card>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import Card from "primevue/card";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import FlashMessage from "../Services/FlashMessage";
import Checkbox from 'primevue/checkbox';
import Toast from 'primevue/toast';
import axios from "axios";

export default {
    layout: AppLayout,
    components: {
        Card,
        InputText,
        Button,
        Checkbox,
        "p-toast": Toast,
    },

    props: ['data'],
    mixins: [FlashMessage],
    data() {
        return {
            model: {
                ips: this.data.ips,
            },
        }
    },

    methods: {
        saveModel() {
            if (this.model) {
                axios.post(this.route('api.security_update'), this.model)
                    .then((result) => {
                        this.$toast.add({severity: 'info', summary: 'Збережено', detail: '', life: 3000});
                    }).catch((error) => {
                        console.log(error);
                    })
            }
        }
    },
}
</script>